import { getCognitoHostedUIUrl } from '../config/api';

// Generate secure random state
const generateState = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

// Store state in sessionStorage for validation
const storeState = (state: string): void => {
  sessionStorage.setItem('oauth_state', state);
};

const getStoredState = (): string | null => {
  return sessionStorage.getItem('oauth_state');
};

const clearState = (): void => {
  sessionStorage.removeItem('oauth_state');
};

// Auth Service
class AuthService {
  // Initiate login - redirects to Cognito Hosted UI
  login(): void {
    try {
      const state = generateState();
      storeState(state);
      const url = getCognitoHostedUIUrl(state);
      
      // Use window.location.replace to avoid back button issues
      window.location.replace(url);
    } catch (error) {
      console.error('Error in login:', error);
      alert('Failed to initiate login. Check console for details.');
    }
  }

  // Validate state parameter
  validateState(receivedState: string): boolean {
    const storedState = getStoredState();
    if (!storedState) {
      return false;
    }
    const isValid = storedState === receivedState;
    if (isValid) {
      clearState();
    }
    return isValid;
  }

  // Check if user is authenticated (has session cookie)
  // Note: We can't directly check httpOnly cookies, so we'll rely on API calls
  async checkAuth(): Promise<boolean> {
    // Try to call a protected endpoint
    // If it succeeds, user is authenticated
    // TODO: Implement actual API call
    return true; // Placeholder - will be determined by API call
  }
}

export const authService = new AuthService();

